/* istanbul ignore file */
export { ImageContainerModule } from './image-container.module';
export { ImageContainerComponent } from './image-container.component';
